import {HttpRequest} from '../../../settings/HttpRequest/HttpRequest';

export const ClaveUnidadMedidaService = {
	Listar: () => {
		let params = {};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Clave_Unidad_Medida_Datos', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Agregar: (form) => {
		let params = {
			clave_unidad_medida: form.clave_unidad_medida,
			unidad_medida: form.unidad_medida,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Clave_Unidad_Medida_Guardar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Modificar: (form) => {
		let params = {
			id_cat_clave_unidad_medida: form.id_cat_clave_unidad_medida,
			clave_unidad_medida: form.clave_unidad_medida,
			unidad_medida: form.unidad_medida,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Clave_Unidad_Medida_Modificar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Eliminar: (id_cat_clave_unidad_medida) => {
		let params = {
			id_cat_clave_unidad_medida: id_cat_clave_unidad_medida
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Clave_Unidad_Medida_Eliminar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	}
};
